import { translationsConfig } from '../../sources';
import { DEFAULT_LOCALE } from '../../constants';
export const getTranslationsFileName = (locale) => {
    const translation = translationsConfig[locale];
    if (translation !== undefined) {
        return translation.fileName;
    }
    const [shortLocale] = locale.split('-');
    const translationFile = translationsConfig[shortLocale];
    return translationFile !== undefined
        ? translationFile.fileName
        : DEFAULT_LOCALE;
};
//# sourceMappingURL=getTranslationsFileName.js.map